// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search_container[data-v-7e9dc57f]{background-repeat:no-repeat;background-size:cover;background-position:50%;position:relative;border-radius:8px;min-height:unset}.search_background[data-v-7e9dc57f]{background:hsla(0,0%,100%,.27);-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);border-radius:20px;width:1136px;max-width:calc(100% - 24px);padding:0}", ""]);
// Exports
module.exports = exports;
